export function getErrorData(error) {
	let errorData = error;
    if (typeof errorData === 'object') {
        errorData = Object.values(errorData);
    } else if (typeof errorData === 'string') {
        errorData = [errorData];
    }
    return errorData;
}
